import React from 'react';
import cn from 'classnames';

import EditableRow from 'components/EditableRow';

import styles from './styles.module.scss';

const SimoDeviceTable = ({ simoDevice, diagnostic, handleUpdateField }) => {
  const {
    id,
    name,
    user_profile,
    serial_number,
    imei,
    account_name,
    simo_status,
    device_type_name,
    appliance_status,
  } = simoDevice || {};
  return (
    <table className={cn('table', styles.table)}>
      <tbody>
        <tr>
          <th>Id</th>
          <td>{id}</td>
          <td></td>
        </tr>
        {simo_status && simo_status !== 'expired' ? (
          <EditableRow
            name="name"
            label="Name"
            value={name}
            type="input"
            save={handleUpdateField}
            thirdRowWidth="255px"
          />
        ) : (
          <tr>
            <th>Name</th>
            <td>{name}</td>
            <td></td>
          </tr>
        )}
        <tr>
          <th>User Profile ID</th>
          <td>{user_profile}</td>
          <td></td>
        </tr>
        <tr>
          <th>Device SN</th>
          <td>{serial_number}</td>
          <td></td>
        </tr>
        <tr>
          <th>IMEI</th>
          <td>{imei}</td>
          <td></td>
        </tr>
        <tr>
          <th>Account Name</th>
          <td>{account_name}</td>
          <td></td>
        </tr>
        <tr>
          <th>Status</th>
          <td>{simo_status}</td>
          <td></td>
        </tr>
        <tr>
          <th>Connection Status</th>
          <td>{diagnostic?.connection_status_name}</td>
          <td></td>
        </tr>
        <tr>
          <th>Device Type</th>
          <td>{device_type_name}</td>
          <td></td>
        </tr>
        <tr>
          <th>Appliance Status</th>
          <td>{appliance_status}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );
};

export default SimoDeviceTable;
